/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-07-16 10:27:28
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2022-07-16 11:03:51
 * @FilePath: \manger\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
  },
  mutations: {
    increment(state, data) {
      state.isLogin = data.isl
    }
  },
  actions: {
  },
  modules: {
  }
})
